//
//
//
//
//
//

import {mapActions} from "vuex"
export default {
  name: 'app',
  data(){
    return {
      backbtn:false
    }
  },
  watch:{
    $route(to,from){
      if(to.path == '/login' && from.path!='/'&& from.path!=''){
        let temp = {
          path:from.path,
          query:JSON.parse(JSON.stringify(from.query))
        }
        this.setOriginRoute(temp)
      }
      if(this.$route.query.ispc){//飞飞调用,存储是否显示返回按钮                
        this.$store.dispatch('backbtn',this.$route.query.ispc);
        this.backbtn=true;
      }
    }
  },
  mounted() {
    //获取缓存的用户信息
    const info = window.localStorage.getItem('info') || '';
    if(info){
        console.log(this.$store)
      this.$store.dispatch('UserInfo',JSON.parse(info));
    }

  },
  methods:{
    ...mapActions("routes", ["setOriginRoute"]),
  },

}



// WEBPACK FOOTER //
// ./src/App.vue